import _ from 'lodash';

import { 
  RequestState, 
  OPERATION_ADD,
  OPERATION_REMOVE,
  OPERATION_REPLACE, } from 'constants/constants';
const { SUCCESS } = RequestState;


export function getOperation(action, entity_type) {
  if(_.includes(DeleteActionKeys, action.type) && DeleteActions[action.type] === entity_type) {
    if(action.result && action.result === RequestState.SUCCESS) {
        return OPERATION_REMOVE;
    } else if(action.result) {
      return OPERATION_ADD;
    } else {
      return OPERATION_REMOVE;
    }
  }
  return OPERATION_ADD;
}

const ModelState = {
  init: modelTypes => {
    // Gather actions from all model objects
    ModelState.actions = _.assign({}, _.map(modelTypes, e => [ e.actions ]));

    // Create initial model spec from model objects
    ModelState.spec = _.assign({}, ..._.map(modelTypes, e => e.spec));

    // Gather state reducers from all model objects
    let reducers = modelTypes
      |> _.map(#, 'reducer')
      |> _.compact

    ModelState.reducer = function(state = ModelState.spec, action) {
      var { json, type } = action;
      var body = json?.body;
      // Go through model reducer functions
      return _.reduce(reducers, (s, f) => f(s, type, body, action, json), state);
    }

  },
  spec: {},
  actions: {},
  reducer: null,
};

export default ModelState;

